/**
 * Token a notification title carries when its link belongs inside the sentence
 * instead of on a separate call-to-action line. The backend leaves it in the
 * translated title; NotificationTitle.vue swaps it for the `link` payload.
 */
export const LINK_PLACEHOLDER = '{link}'

export const useHasInlineLink = (notification) =>
  Boolean(notification?.link) &&
  Boolean(notification?.title?.includes(LINK_PLACEHOLDER))
